import { useApiClient } from '../../hooks/useApiClient';
import { ChangelogStatus } from '../../types/Changelog/ChangelogStatus.type.ts';

export const useChangelogStatusApi = () => {
  const apiClient = useApiClient();

  return {
    getChangelogStatuses: (): Promise<ChangelogStatus[]> => apiClient(`/changelog_statuses/`),
  };
};
